<template>
    <div id="">
    <!-- <my-tour v-if="" :steps="steps" name="steps-cadastro-empresas"></my-tour> -->
        <section id="content">
            <div class="container">
                 <TituloPagina titulo="Desempenho das Franquias" />
                <div class="row">
                    <div class="col m12">
                        <div style="position: absolute; width: 90%">
                            <input type="text" id="dt_inicio" :data-value="filtro.data_ini" v-model="filtro.data_ini" class="col m2">
                            <input type="text" id="dt_fim" :data-value="filtro.data_fim" v-model="filtro.data_fim" class="col m2 ml-1">
                            <i class="material-icons md-32 grey-text clear asc" :class="filtro.order == 'asc' ? 'active': ''" style="margin-top: 16px"  @click="setOrder('asc')">filter_list</i>
                            <i class="material-icons md-32 grey-text clear desc" :class="filtro.order == 'desc' ? 'active': ''" style="margin-top: 16px" @click="setOrder('desc')">filter_list</i>
                            <span class="info" v-html="fraseOrder"></span>
                            <div class="Search input-field col m3 input-search" style="margin-top:0">
                                <div class="row">
                                    <div class="input-field col s12"  style="margin-top:0">
                                        <i class="material-icons prefix">person_outline</i>
                                        <input type="text" id="autocomplete-input" class="autocomplete" autocomplete="off">
                                        <label for="autocomplete-input">Incluir Franquia</label>
                                    </div>
                                </div>
                            </div>
                            <button
                                class="btn btn-default waves-effect waves-light right hide-on-med-and-down"
                                style="margin-top: 12px"
                                @click="downloadPDF"
                            >
                                <i class="material-icons left">file_download</i>
                                Exportar
                            </button>

                        </div>
                    </div>
                    <div class="col m12" style="margin-top: 100px;">
                        <div class="chip mt-3" v-for="franquia in addedFranquias">
                            {{franquia}}
                            <i @click="removeFranquia(franquia)" class="close material-icons">close</i></div>
                        </div>

                        <div class="small col card-panel m12" >
                            <desempenho-historico-franquias @load="showLoading" :filtros="filtro" @removeFranquia="cleanFranquias" :addItem= "selectedFranquiaId" :removeItem="removeFranquiaId"/>
                            <!-- <i class="material-icons carousel-icon">keyboard_arrow_right</i>                         -->
                        </div>
                    </div>
                </div>
        </section>
    </div>
</template>
<style lang="scss">
    @import './Desempenho.scss';
</style>
<script>
    import Auth from '@/store/auth';
    import TituloPagina from '@/components/common/TituloPagina';
    import MyTour from '@/components/common/MyTour.vue'
    import { get, post } from '@/helpers/api';
    import { DONO, GERENTE, CORRETOR, PARCEIRO, MASTER } from '@/constants/funcionarioCargo.js';
    import DATEPICKER  from '@/constants/datepicker.js';
    import DesempenhoHistoricoFranquias from '@/components/charts/DesempenhoHistoricoFranquias';
    // import DesempenhoHistoricoFuncionarios from '@/components/charts/DesempenhoHistoricoFuncionarios';
    import Card from '@/components/common/Card/Card';
    import { Event } from '@/helpers/events';
    import Message from '@/helpers/message';
    import { download } from '@/pdf/DesempenhoFranquia';

    export default {
        components: {
            TituloPagina,
            DesempenhoHistoricoFranquias,
            // DesempenhoHistoricoFuncionarios,
            MyTour,
            Card,
        },
        data: () => ({
            fraseOrder: '',
            selectedFranquiaId: null,
            removeFranquiaId: null,
            addedFranquias: [],
            selectedFranquia: null,
            franquias: [],
            filtro:{
                data_ini: moment().subtract(3, 'months').format('DD/MM/YYYY'),
                data_fim: moment().format('DD/MM/YYYY'),
                order: 'desc'
            },
            // showFuncionarioGrafico: false,
            infosFuncionario: '',

        }),
        created() {
        this.setFraseOrder();
        const self  = this;
        //  Event.$on('chartClick', data => {
        //     self.showFuncionarioGrafico = true;
        //     self.infosFuncionario       = data;
        // });
        },
        mounted() {
            const configPick = DATEPICKER;

            $('#dt_inicio').pickadate({
                ...configPick,
                onSet: (context) => {
                    if(context.select){
                        this.onDateSelected(moment(context.select).format('DD/MM/YYYY'), 'data_ini');
                    }
                }
            });
            $('#dt_fim').pickadate({
                ...configPick,
                onSet: (context) => {
                    this.onDateSelected(moment(context.select).format('DD/MM/YYYY'), 'data_fim');
                    }
            });
            const self = this;
            get('empresa/lista-franquias').then(response => {
                self.franquias = response.data.result.data;
                let autosuggestData = {};

                self.franquias.forEach(franquia => {
                    if(franquia.nome_empresa){
                        autosuggestData[franquia.nome_empresa] = null;
                    }
                })
                $('input.autocomplete').autocomplete({
                    data: autosuggestData,
                    onAutocomplete: function(val){
                        if(!self.addedFranquias.includes(val)){
                            self.selectedFranquia = val;
                            self.addedFranquias.push(val);
                            $('#autocomplete-input').val('');
                        }else{
                             Message.messageError('Franquia já adicionada');
                             self.selectedFranquiaId = null;
                        }
                        // autosuggestData = {};
                        // self.franquias.forEach(franquia => {
                        //     if(franquia.nome_empresa !== self.selectedFranquia || !self.addedFranquias.includes(franquia.nome_empresa)){
                        //         autosuggestData[franquia.nome_empresa] = null;
                        //     }
                        // })
                        // $('input.autocomplete').autocomplete('destroy');
                    },
                });
            }).catch(err => console.log(err))

        },

        watch:{
            selectedFranquia(){
               this.selectedFranquiaId = this.getSelectedFranquiaId(this.selectedFranquia);
               this.$emit('selectedFranquiaId');
            },
            'filtro.data_fim'(){
                this.$emit('filtros');
            },
            'filtro.data_ini'(){

                console.log(7777888888, filtro.data_ini);
                if(this.filtro.data_ini){
                    this.$emit('filtros');
                }

            },

        },
        methods: {
            downloadPDF(){
                this.showLoading();
                const self = this;
                const dt_ini = moment(self.filtro.data_ini, 'DD/MM/YYYY').format('YYYY-MM-DD');
                const dt_fim = moment(self.filtro.data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD');

                post('grafico/lista-desempenhos',{data_ini: dt_ini, data_fim: dt_fim, order: 'desc'}).then(function (response) {
                    download(response.data.result.data, {
                        fileName: `relatorio_franquia_${self.filtro.data_ini}_${self.filtro.data_fim}`,
                        subTitle: `Data: ${self.filtro.data_ini} a ${self.filtro.data_fim}, Ordenação decrescente lead efetivados`,
                    });
                    self.showLoading(false);
                }).catch(err =>  self.$emit('load', true))

            },
 ///
            setFraseOrder(){
                if(this.filtro.order == 'asc'){
                    this.fraseOrder = `Franquias de <b>pior</b> desempenho`;
                }else if(this.filtro.order == 'desc'){
                    this.fraseOrder = 'Franquias de <b>melhor</b> desempenho';
                }
            },
            showLoading(show = true){
                this.$parent.$emit('showLoading', show);
            },
            getSelectedFranquiaId(selectedFranquia){
                if(selectedFranquia){
                    let id_franquia = this.franquias.filter(franquia => franquia.nome_empresa === selectedFranquia);
                   if(id_franquia.length){
                       id_franquia = id_franquia[0].id_empresa;
                   }
                    return id_franquia;
                }else{
                    return selectedFranquia;
                }
            },
            setOrder(order){
                if(this.filtro.order != order){
                    this.filtro.order = order;
                    this.filtro = Object.assign({}, this.filtro, { order });
                    this.setFraseOrder();
                }
            },
            cleanFranquias(id_franquia){
                let franquia_nome = this.franquias.filter(franquia => franquia.id_empresa === id_franquia);
                if(franquia_nome.length){
                    franquia_nome = franquia_nome[0].nome_empresa;
                }
                this.addedFranquias = this.addedFranquias.filter(item => item !== franquia_nome);
            },
            removeFranquia(franquia){

                this.removeFranquiaId = this.getSelectedFranquiaId(franquia);
                this.addedFranquias = this.addedFranquias.filter(item => item !== franquia);
                this.selectedFranquiaId = null;
                this.selectedFranquia   = null;
                this.$emit('removeFranquia');
            },
             onDateSelected(newValue, field) {

                 console.log('dataaaaaaaaaaa', this.filtro, newValue);
                const tempFiltro = {};
                tempFiltro[field] = newValue;
                this.filtro = Object.assign({}, this.filtro, tempFiltro);
                console.log('dataaaaaaaaaaa', this.filtro, newValue);
            },
        }

    };
</script>



// WEBPACK FOOTER //
// src/components/relatorios/Desempenho.vue